<template>
  <div class="RwvContent inner-section">
    <RwvContentMarkdown v-if="content.type == 'Markdown'" :markdown="content.data"/>
    <RwvContentImage v-else-if="content.type == 'Image'" :image="content.data"/>
    <RwvContentMarkdownToggle v-else-if="content.type == 'MarkdownToggle'" :data="content.data" :index="index"/>
    <RwvContentHtml v-else-if="content.type == 'HTML'" :html="content.data" :index="index"/>
    <RwvContentToggle v-else-if="content.type == 'Toggle' && isWithToggle" :content="content.data" :index="index"/>
    <RwvContentEmbed v-else-if="content.type == 'Embed'" :data="content.data" :index="index"/>
    <RwvContentSlider v-else-if="content.type == 'Slider'" :data="content.data" :index="index"/>
    <RwvContentAd v-else-if="content.type == 'Ad'" :data="content.data" :index="index"/>
    <RwvContentPdf v-else-if="content.type == 'Pdf'" :data="content.data"/>
    <div v-else class="error">
      <p>Nicht unterstützter Inhaltstyp.</p>
    </div>
  </div>
</template>

<script>
import RwvContentMarkdown from "@/components/Contents/Markdown/ContentMarkdown";
import RwvContentMarkdownToggle from "@/components/Contents/MarkdownToggle/ContentMarkdownToggle";
import RwvContentImage from "@/components/Contents/Image/ContentImage";
import RwvContentHtml from "@/components/Contents/Html/ContentHtml";
import RwvContentToggle from "@/components/Contents/Toggle/ContentToggle";
import RwvContentEmbed from "@/components/Contents/Embed/ContentEmbed";
import RwvContentSlider from "@/components/Contents/Slider/ContentSlider";
import RwvContentPdf from "@/components/Contents/Pdf/ContentPdf";
import RwvContentAd from "@/components/AdInArticle";

export default {
  name: "RwvContent",
  components: {
    RwvContentMarkdown,
    RwvContentMarkdownToggle,
    RwvContentImage,
    RwvContentHtml,
    RwvContentToggle,
    RwvContentEmbed,
    RwvContentSlider,
    RwvContentAd,
    RwvContentPdf
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isWithToggle: {
      type: Boolean,
      default: true
    }
  },
};
</script>

<style lang="scss">
.RwvContent {
  margin-top: 2em;
  margin-bottom: 2em;
}
</style>
